import * as React from 'react'
import { memo } from 'react'
const SvgPlus = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
  >
    <path d="M5.759 9h.483V6.241H9v-.483H6.241V3h-.483v2.759H3v.483h2.759Zm.244 3a5.85 5.85 0 0 1-2.34-.472 6.065 6.065 0 0 1-1.906-1.282 6.056 6.056 0 0 1-1.283-1.9A5.834 5.834 0 0 1 0 6a5.85 5.85 0 0 1 .472-2.34 6.065 6.065 0 0 1 1.282-1.906 6.056 6.056 0 0 1 1.9-1.283A5.833 5.833 0 0 1 6 0a5.849 5.849 0 0 1 2.34.472 6.064 6.064 0 0 1 1.906 1.282 6.055 6.055 0 0 1 1.283 1.9A5.833 5.833 0 0 1 12 6a5.849 5.849 0 0 1-.472 2.34 6.065 6.065 0 0 1-1.282 1.906 6.056 6.056 0 0 1-1.9 1.283A5.833 5.833 0 0 1 6 12Z" />
  </svg>
)
const Memo = memo(SvgPlus)
export default Memo
